import { useT } from "src/internationalization";
import { AlertStatus } from "src/types/alert";

export const useGetAlertStatusConfig = (): Record<
  AlertStatus,
  { name: AlertStatus; status: AlertStatus; label: string }
> => {
  const t = useT();

  return {
    assigned: {
      name: "assigned",
      status: "assigned",
      label: t("page.tab.status.assigned"),
    },
    notAssigned: {
      name: "notAssigned",
      status: "notAssigned",
      label: t("page.tab.status.not.assigned"),
    },
    closed: {
      name: "closed",
      status: "closed",
      label: t("page.tab.status.closed"),
    },
    canceled: {
      name: "canceled",
      status: "canceled",
      label: t("page.tab.status.canceled"),
    },
  };
};
